import http from "@/axios/http-common";
import ErrorAlert from "@/utility/ErrorAlert";
import {
  DaftarPasienBankDarahFilter,
  DaftarPasienBankDarahRow,
  OrderBankDarahFilter,
  OrderBankDarahListResponse,
  OrderSumber,
  SerahTerimaListResponse,
  SerahTerimaResponse,
  SerahTerimaSampelDarah
} from "@/types/order_bank_darah";

function tolak(err: any) {
  ErrorAlert.showErrorAlert(err);
  return Promise.reject(err);
}

export function paramsFilter(f: OrderBankDarahFilter) {
  return {
    tgl_start: f.tgl_start || undefined,
    tgl_end: f.tgl_end || undefined,
    tgl_kolom: f.tgl_kolom || undefined,
    status: f.status && f.status.length ? f.status.join(",") : undefined,
    jenis: f.jenis && f.jenis.length ? f.jenis.join(",") : undefined,
    unit_id: f.unit_id || undefined,
    term: f.term || undefined
  };
}

async function list(f: OrderBankDarahFilter): Promise<OrderBankDarahListResponse> {
  const res = await http
    .getDataParam("/order-bank-darah", { params: paramsFilter(f) })
    .catch(tolak);
  return res.data.data;
}

async function daftarPasien(
  f: DaftarPasienBankDarahFilter
): Promise<DaftarPasienBankDarahRow[]> {
  const res = await http
    .getDataParam("/order-bank-darah/daftar-pasien", {
      params: {
        tgl_start: f.tgl_start || undefined,
        tgl_end: f.tgl_end || undefined,
        unit_id: f.unit_id || undefined,
        term: f.term || undefined,
        status: f.status || undefined
      }
    })
    .catch(tolak);
  return res.data.data;
}

async function count(): Promise<number> {
  const res = await http.getData("/order-bank-darah/count");
  return res.data.data.order_masuk;
}

async function terima(sumber: OrderSumber, id: number) {
  const res = await http
    .putData(`/order-bank-darah/${sumber}/${id}/terima`, {})
    .catch(tolak);
  return res.data;
}

async function batal(sumber: OrderSumber, id: number, alasan: string) {
  const res = await http
    .putData(`/order-bank-darah/${sumber}/${id}/batal`, { alasan })
    .catch(tolak);
  return res.data;
}

async function showSerahTerima(
  sumber: OrderSumber,
  id: number
): Promise<SerahTerimaResponse> {
  const res = await http
    .getData(`/order-bank-darah/${sumber}/${id}/serah-terima`)
    .catch(tolak);
  return res.data.data;
}

async function simpanSerahTerima(
  sumber: OrderSumber,
  id: number,
  data: SerahTerimaSampelDarah
) {
  const res = await http
    .postData(`/order-bank-darah/${sumber}/${id}/serah-terima`, data)
    .catch(tolak);
  return res.data;
}

async function hapusSerahTerima(sumber: OrderSumber, id: number) {
  const res = await http
    .deleteData(`/order-bank-darah/${sumber}/${id}/serah-terima`)
    .catch(tolak);
  return res.data;
}

async function daftarSerahTerima(f: {
  tgl_start: string | null;
  tgl_end: string | null;
  unit_id?: string | null;
  term?: string | null;
  final?: "ya" | "tidak" | "" | null;
}): Promise<SerahTerimaListResponse> {
  const res = await http
    .getDataParam("/order-bank-darah/serah-terima", {
      params: {
        tgl_start: f.tgl_start || undefined,
        tgl_end: f.tgl_end || undefined,
        unit_id: f.unit_id || undefined,
        term: f.term || undefined,
        final: f.final || undefined
      }
    })
    .catch(tolak);
  return res.data.data;
}

export default {
  list,
  daftarPasien,
  count,
  terima,
  batal,
  showSerahTerima,
  simpanSerahTerima,
  hapusSerahTerima,
  daftarSerahTerima
};
